import { keyframes } from '@mui/system';
import getTheme from 'config/themes/base';

const theme = getTheme();

const shimmer = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

const upgradeButtonGradient = keyframes`
  0% {
    background-position: 200% 0px;
  }
  100% {
    background-position: -200% 0px;
  }
`;

export default {
  root: {
    padding: '0 12px 14px',
    borderTop: 'none',
  },
  rootDrawerOpen: {
    display: 'block',
  },
  rootDrawerClose: {
    display: 'none',
  },
  upgradeCardContainer: {
    position: 'relative',
    mx: 0.75,
    mb: 1.5,
    px: 1.75,
    py: 2,
    borderRadius: 3,
    border: '1px solid',
    borderColor: 'hsl(30 12% 90%)',
    overflow: 'hidden',
    background: `
          linear-gradient(
            to bottom right,
            hsl(348 35% 95%),   /* wine-light */
            hsl(0 0% 100%),     /* card */
            hsl(38 55% 94%)     /* gold-light */
          )
        `,
  },
  upgradeCardShimmer: {
    position: 'absolute',
    inset: 0,
    borderRadius: 3,
    background: 'linear-gradient(110deg, transparent 25%, hsl(348 58% 32% / 0.05) 37%, transparent 63%)',
    backgroundSize: '200% 100%',
    animation: `${shimmer} 3s ease-in-out infinite`,
    pointerEvents: 'none',
  },
  upgradeCard: { position: 'relative', zIndex: 1 },
  upgradeHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 1,
  },
  upgradeTitleIcon: {
    fontSize: 20,
    marginRight: 1,
    color: '#c89a3d',
  },
  upgradeTitle: {
    fontSize: 16,
    fontWeight: 600,
  },
  upgradeDescription: {
    fontSize: 12,
    lineHeight: 1.75,
    marginBottom: 1.75,
    color: theme.palette.primary.sideBarTextColor,
    opacity: '0.78',
    whiteSpace: 'normal',
    overflow: 'visible',
    textOverflow: 'unset',
    wordBreak: 'break-word',
  },
  upgradeButton: {
    width: '100%',
    borderRadius: 2.5,
    padding: 1,
    textTransform: 'none',
    color: '#fff',
    fontWeight: 600,
    fontSize: 12,
    background: 'linear-gradient(92deg, #7f1530, #8f1f3a, #7f1530)',
    backgroundSize: '200% 200%',
    animation: `${upgradeButtonGradient} 4s ease infinite`,
    '&:hover': {
      background: 'linear-gradient(92deg, #6f1027, #7f1530, #6f1027)',
      backgroundSize: '200% 200%',
      animation: `${upgradeButtonGradient} 4s ease infinite`,
    },
  },
  upgradeButtonIcon: {
    marginRight: 1,
    fontSize: 16,
  },
  footerTexts: {
    margin: '4px 6px',
  },
  versionText: {
    display: 'flex',
    alignItems: 'center',
  },
  footerTypographies: {
    fontSize: 12,
    color: theme.palette.primary.footerTextColor,
    textAlign: 'left',
    height: '15px',
  },
  copyRight: {
    marginLeft: 1,
  },
};
